export const paymentStatus: Record<
  | "NOT_PAY"
  | "PAY_PROCESS"
  | "PAY_SUCCESS"
  | "PAY_FAILED"
  | "REFUND"
  | "PARTIAL_REFUND"
  | "REFUND_PROCESS"
  | "REFUND_FAILED"
  | "REFUND_APPLY"
  | "CANCEL",
  number
> = {
  // 0=尚未付款 1=付款處理中 2=付款成功 3=付款失敗 4=已退款 5=部分退款 6=退款處理中 7=退款失敗 8=退款申請中
  NOT_PAY: 0,
  PAY_PROCESS: 1,
  PAY_SUCCESS: 2,
  PAY_FAILED: 3,
  REFUND: 4,
  PARTIAL_REFUND: 5,
  REFUND_PROCESS: 6,
  REFUND_FAILED: 7,
  REFUND_APPLY: 8,
  CANCEL: 9,
};
